<template>
    <component
        :is="RequestComponent"
        v-bind="{
            value,
            program,
            employee,
            employer,
        }"
        v-on="{
            input,
        }"
    >
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
    </component>
</template>

<script>
import { initExpoProgram } from "@/assets/variables";
import RequestToEmployee from "./request/request-to-employee.vue";
import RequestToEmployer from "./request/request-to-employer.vue";
import RequestToNobodies from "./request/request-to-nobodies.vue";

export default {
    components: {
        RequestToEmployee,
        RequestToEmployer,
        RequestToNobodies,
    },
    props: {
        value: { type: Object, default: null },
        program: { type: Object, default: initExpoProgram },
        employee: { type: Object, default: null },
        employer: { type: Object, default: null },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },
    computed: {
        RequestComponent() {
            if (this.isUserEmployee) return "request-to-employer";

            if (this.isUserEmployer) return "request-to-employee";

            return "request-to-nobodies";
        },
    },
    methods: {
        input(matching) {
            this.$emit("input", matching);
        },
    },
};
</script>

<style>
</style>